import React, { useState } from "react";
import { passwordError, PASSWORD_HINT } from "@/lib/passwordPolicy";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function RegisterPage() {
    const { register } = useAuth() || {};
    const navigate = useNavigate();
    const [form, setForm] = useState({ full_name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (passwordError(form.password)) {
            setError(passwordError(form.password));
            return;
        }
        setLoading(true);
        try {
            await register(form.full_name, form.email, form.password);
            navigate("/my-bookings");
        } catch (err) {
            setError(err.response?.data?.detail || "Kayıt başarısız");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="register-page" className="min-h-screen bg-slate-50 dark:bg-slate-950">
            <Navbar />
            <div className="container mx-auto px-4 max-w-md py-16">
                <div className="p-8 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-soft">
                    <h1 className="font-display text-3xl font-bold text-slate-900 dark:text-white mb-2">Üye Ol</h1>
                    <p className="text-sm text-slate-500 mb-6">Zaten üye misiniz? <Link to="/login" className="text-sky-500 font-semibold hover:underline">Giriş yapın</Link></p>

                    <form onSubmit={onSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">Ad Soyad</label>
                            <input data-testid="register-name" type="text" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">E-posta</label>
                            <input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">Şifre ({PASSWORD_HINT})</label>
                            <input data-testid="register-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white" />
                        </div>
                        {error && <div data-testid="register-error" className="p-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
                        <button data-testid="register-submit" type="submit" disabled={loading} className="w-full py-3 rounded-xl bg-sky-500 hover:bg-sky-600 text-white font-semibold disabled:opacity-60">
                            {loading ? "Kayıt olunuyor..." : "Üye Ol"}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
